import { SORT_FIELDS } from "./filters";
import {
  CONFIRM_OK_BUTTON_TEXT,
  CONFIRM_REJECT_BUTTON_TEXT,
  WARNING_SINGLE_BUTTON_TEXT
} from "./otherTexts";
import { TRANSACTION_TYPES } from "./transactions";

export const PAYMENT = TRANSACTION_TYPES.PAYMENT;
export const RECEIVE = TRANSACTION_TYPES.RECEIVE;
export const ACTIVITY = 3;
export const TRANSFER = 4;

export const Names = {
  [PAYMENT]: "پرداخت",
  [RECEIVE]: "دریافت",
  [ACTIVITY]: "کارکرد",
  [TRANSFER]: "انتقالی"
};

export const REDUCER_NAMES = {
  PETTY_CASHIER: "PettyCashierAccountReview",
  MANAGER: "ManagerAccountReview"
};

export const REDUCER_FIELDS = {
  PAYMENT: {
    sum_name: "payment",
    amount_name: SORT_FIELDS.PAYMENT_AMOUNT
  },
  RECEIVE: {
    sum_name: "receive",
    amount_name: SORT_FIELDS.RECEIVE_AMOUNT
  }
};

//S = single ; DEL = delete; M = multi; OTH = other
export const CNFRM_ACTION = {
  DEL: "DEL",
  CPY: "CPY"
};
export const CNFRM_NUM_DATA = {
  S: "SINGLE",
  M: "MULTI"
};
export const CNFRM_ALLOW_ACTION = {
  BLK: "NOT_ALLOWED",
  ASK: "ASK_BEFORE_ALLOW",
  ALW: "ALLOWED"
};
export const S_DEL_RMV = `${CNFRM_NUM_DATA.S}_${CNFRM_ACTION.DEL}_${CNFRM_ALLOW_ACTION.ALW}`;
export const S_DEL_N_RMV = `${CNFRM_NUM_DATA.S}_${CNFRM_ACTION.DEL}_${CNFRM_ALLOW_ACTION.BLK}`;
export const S_DEL_IN_IMPREST_RMV = `${CNFRM_NUM_DATA.S}_${CNFRM_ACTION.DEL}_${CNFRM_ALLOW_ACTION.ASK}`;
export const M_DEL_N_RMV = `${CNFRM_NUM_DATA.M}_${CNFRM_ACTION.DEL}_${CNFRM_ALLOW_ACTION.BLK}`;
export const M_CPY_TO_BAS_INF_ACSES_PRJ = `${CNFRM_NUM_DATA.M}_${CNFRM_ACTION.CPY}_${CNFRM_ALLOW_ACTION.ALW}`;
export const M_CPY_TO_BAS_INF_DNY_PRJ = `${CNFRM_NUM_DATA.M}_${CNFRM_ACTION.CPY}_${CNFRM_ALLOW_ACTION.ASK}`;
export const CONFIRM_TYPES = param => {
  return {
    [S_DEL_IN_IMPREST_RMV]: {
      message: `این ${param} در گزارش تنخواه، گزارش شده است، با حذف آن مانده گزارش‌های تنخواه تغییر خواهند کرد. آیا از ادامه این عملیات اطمینان دارید؟`,
      rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
      successButton: CONFIRM_OK_BUTTON_TEXT
    },
    [S_DEL_RMV]: {
      message: `آیا از حذف این ${param} اطمینان دارید؟`,
      rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
      successButton: CONFIRM_OK_BUTTON_TEXT
    },
    [S_DEL_N_RMV]: {
      message: `این ${param} قابل حذف نیست!`,
      rejectButton: WARNING_SINGLE_BUTTON_TEXT,
      successButton: ""
    },
    [M_DEL_N_RMV]: {
      message: `تراکنش‌ سطر ${param} به دلیل اینکه در یک تنخواه ارسال شده استفاده شده‌است قابلیت حذف ندارد. برای حذف این موارد نیاز است که مدیر شرکت، تنخواه ارسال‌شده را بازگشت بزند.`,
      rejectButton: WARNING_SINGLE_BUTTON_TEXT,
      successButton: ""
    },
    [M_DEL_RMV]: {
      message: `شما ${param} مورد را انتخاب کرده‌اید. آیا از حذف موارد انتخابی مطمئن هستید؟ با حذف اطلاعات موارد انتخابی امکان بازگشت آن‌ها وجود نخواهد داشت.`,
      rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
      successButton: CONFIRM_OK_BUTTON_TEXT
    },
    [M_CPY_TO_BAS_INF_ACSES_PRJ]: {
      message: `آیا می‌خواهید کپی تراکنش‌های انتخاب شده را به شرکت ${param} منتقل کنید؟`,
      rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
      successButton: CONFIRM_OK_BUTTON_TEXT
    },
    [M_CPY_TO_BAS_INF_DNY_PRJ]: {
      message: `شما در شرکت ${param} امکان ویرایش سرفصل‌حساب، مرکز هزینه، طرف حساب و هشتگ را ندارید. بهتر است ابتدا از مدیر خود بخواهید این موارد را ایجاد کند و سپس تراکنش‌ها در آن شرکت کپی کنید. آیا هنوز هم می‌خواهید تراکنش‌های انتخابی را در این شرکت کپی کنید؟`,
      rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
      successButton: CONFIRM_OK_BUTTON_TEXT
    }
  };
};

export const M_DEL_RMV = `${CNFRM_NUM_DATA.M}_${CNFRM_ACTION.DEL}_${CNFRM_ALLOW_ACTION.ALW}`;
// export const M_CPY_TO_OTH_OWN_PRJ = `${CNFRM_NUM_DATA.M}_${CNFRM_ACTION.CPY}_${CNFRM_ALLOW_ACTION.ALW}`;
// export const M_CPY_TO_OTH_PRJ = `${CNFRM_NUM_DATA.M}_${CNFRM_ACTION.CPY}_${CNFRM_ALLOW_ACTION.ASK}`;
// export const CONFIRM_TYPES = param => {
//   return {
//     [S_DEL_IN_IMPREST_RMV]: {
//       message: `این ${param} در گزارش تنخواه، گزارش شده است، با حذف آن مانده گزارش‌های تنخواه تغییر خواهند کرد. آیا از ادامه این عملیات اطمینان دارید؟`,
//       rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
//       successButton: "حذف"
//     },
//     [S_DEL_RMV]: {
//       message: `آیا از حذف این ${param} اطمینان دارید؟`,
//       rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
//       successButton: "حذف"
//     },
//     [S_DEL_N_RMV]: {
//       message: `این ${param} قابل حذف نیست!`,
//       rejectButton: "باشه",
//       successButton: ""
//     },
//     [M_DEL_N_RMV]: {
//       message: `تراکنش‌ سطر ${param} به دلیل اینکه در یک تنخواه ارسال شده استفاده شده‌است قابلیت حذف ندارد. برای حذف این موارد نیاز است که مدیر شرکت، تنخواه ارسال‌شده را بازگشت بزند.`,
//       rejectButton: "باشه",
//       successButton: ""
//     },
//     [M_DEL_RMV]: {
//       message: `شما ${param} مورد را انتخاب کرده‌اید. آیا از حذف موارد انتخابی مطمئن هستید؟ با حذف اطلاعات موارد انتخابی امکان بازگشت آن‌ها وجود نخواهد داشت.`,
//       rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
//       successButton: "حذف"
//     },
//     [M_CPY_TO_OTH_OWN_PRJ]:{
//       message:`آیا می‌خواهید تراکنش‌های انتخاب شده را به شرکت ${param} منتقل کنید؟`,
//       rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
//       successButton: "انتقال به شرکت"
//     },
//     [M_CPY_TO_OTH_PRJ]:{
//       message:`شما در شرکت ${param} امکان ویرایش سرفصل‌حساب، مرکز هزینه و هشتگ را ندارید. بهتر است ابتدا از مدیر خود بخواهید این موارد را ایجاد کند و سپس تراکنش‌ها را به آن شرکت منتقل کنید.`,
//       rejectButton: CONFIRM_REJECT_BUTTON_TEXT,
//       successButton: "انتقال به شرکت"
//     }
//   };
// };
